import {
  GraphQLID,
  GraphQLNonNull,
  GraphQLList,
  GraphQLInputObjectType
} from 'graphql'

export interface OrganizationEntitiesArg {
  readonly organizationID: string
  readonly ids: string[]
}

export const OrganizationEntitiesArgType = new GraphQLInputObjectType({
  name: 'OrganizationEntitiesArg',
  description:
    'Parameters that describe an operation on one or more more entities of a single type within an organization',
  fields: () => ({
    organizationID: {
      description:
        'The ID of the organization for the entities being operated on',
      type: new GraphQLNonNull(GraphQLID)
    },
    ids: {
      description: 'List of IDs of the entities being operated on. ',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(GraphQLID)))
    }
  })
})

export interface OrganizationEntityArg {
  readonly organizationID: string
  readonly id: string
}

export const OrganizationEntityArgType = new GraphQLInputObjectType({
  name: 'OrganizationEntityArg',
  description:
    'Parameters that describe an operation on one entity within an organization',
  fields: () => ({
    organizationID: {
      description:
        'The ID of the organization for the entity being operated on',
      type: new GraphQLNonNull(GraphQLID)
    },
    id: {
      description: 'ID of the entity being operated on. ',
      type: new GraphQLNonNull(GraphQLID)
    }
  })
})
